
import periods from "./Periods.js"
export default {
  id : 1,
  title : "OPEX",
  link: "/abc/kpi/opex",
  template : "pageA",
  i18n : "ABC.OPEX.Title",
  layout : {
    upper1 : {
      name : "OPEX",
      type : "radialBar",
      i18n : "ABC.OPEX.BaseValue",
      url: "/Hyperion/Kpi/OPEX",
      chartData : {
        leftDataTitle: "Actual",
        leftDataTitlei18n: "Actual",
        rightDataTitle: "Budget",
        rightDataTitlei18n: "Budget",
        dataFilter: "KPI_M_k_formatter"
      },
      zoomIn : {
        name : "OPEX Periodic",
        i18n : "ABC.OPEX.Title",
        type : "comparaisonLine",
        url: "/Hyperion/Kpi/PeriodicOPEX",
        chartData : {
          categories : periods,
          leftDataTitle: "Actual",
          leftDataTitlei18n: "Actual",
          rightDataTitle: "Budget",
          rightDataTitlei18n: "Budget",
          dataFilter: "KPI_M_k_formatter"
        }
      }
    },
    upper2 : {
      name : "OPEX Per Oz",
      i18n : "ABC.OPEX.OPEXPerOz",
      type : "radialBar",
      url: "/Hyperion/Kpi/OPEXPerOz",
      chartData : {
        leftDataTitle: "Actual",
        leftDataTitlei18n: "Actual",
        rightDataTitle: "Budget",
        rightDataTitlei18n: "Budget",
        dataFilter: "k_formatter"
      },
      zoomIn : {
        name : "Gold production",
        i18n : "ABC.GoldProduction.Title",
        type : "basicColumn",
        url: "/Hyperion/Kpi/GoldProduction",
        chartData : {
          categories : ["Au"],
          yAxisTitle: "Production (Oz)"
        }
      }
    },
    upper3 : {
      name : "OPEX Per Ton Ore",
      i18n : "ABC.OPEX.OPEXPerTonOre",
      type : "radialBar",
      url: "/Hyperion/Kpi/OPEXPerTonOre",
      chartData : {
        leftDataTitle: "Actual",
        leftDataTitlei18n: "Actual",
        rightDataTitle: "Budget",
        rightDataTitlei18n: "Budget",
        dataFilter: "2Digits"
      },
      zoomIn : {
        name : "Ore Tonnes",
        i18n : "ABC.OreTons.Title",
        type : "basicColumn",
        url: "/Hyperion/Kpi/OreTons",
        chartData : {
          categories : ["Ore"],
          yAxisTitle: "Ore (Tons)"
        }
      }
    },
    middle1 : {
      name : "OPEX Per Oz",
      i18n : "ABC.OPEX.OPEXPerOz",
      type : "comparaisonLine",
      url: "/Hyperion/Kpi/PeriodicOPEXPerOz",
      chartData : {
        categories : periods,
        leftDataTitle: "Actual",
        leftDataTitlei18n: "Actual",
        rightDataTitle: "Budget",
        rightDataTitlei18n: "Budget",
        dataFilter: "2Digits"
      }
    },
    middle2 : {
      name : "OPEX Ton Ore",
      i18n : "ABC.OPEX.OPEXPerTonOre",
      type : "comparaisonLine",
      url: "/Hyperion/Kpi/PeriodicOPEXPerTonOre",
      chartData : {
        categories : periods,
        leftDataTitle: "Actual",
        leftDataTitlei18n: "Actual",
        rightDataTitle: "Budget",
        rightDataTitlei18n: "Budget",
        dataFilter: "2Digits"
      }
    },
    below1 : {
      name : "OPEX OPMining",
      type : "radialBar",
      i18n : "ABC.OPEX.OPMining",
      url: "/Hyperion/Kpi/OPEXOPMining",
      chartData : {
        leftDataTitle: "Actual",
        leftDataTitlei18n: "Actual",
        rightDataTitle: "Budget",
        rightDataTitlei18n: "Budget",
        dataFilter: "KPI_M_k_formatter"
      }
    },
    below2 : {
      name : "OPEX UGMining",
      type : "radialBar",
      i18n : "ABC.OPEX.UGMining",
      url: "/Hyperion/Kpi/OPEXUGMining",
      drillTo: "/abc/kpi/opex/ugmining",
      chartData : {
        leftDataTitle: "Actual",
        leftDataTitlei18n: "Actual",
        rightDataTitle: "Budget",
        rightDataTitlei18n: "Budget",
        dataFilter: "KPI_M_k_formatter"
      }
    },
    below3 : {
      name : "OPEX HLProcessinng",
      type : "radialBar",
      i18n : "ABC.OPEX.HLProcessing",
      url: "/Hyperion/Kpi/OPEXHLProcessing",
      chartData : {
        leftDataTitle: "Actual",
        leftDataTitlei18n: "Actual",
        rightDataTitle: "Budget",
        rightDataTitlei18n: "Budget",
        dataFilter: "KPI_M_k_formatter"
      }
    },
    below4 : {
      name : "OPEX MillProcessinng",
      type : "radialBar",
      i18n : "ABC.OPEX.MillProcessing",
      url: "/Hyperion/Kpi/OPEXMillProcessing",
      chartData : {
        leftDataTitle: "Actual",
        leftDataTitlei18n: "Actual",
        rightDataTitle: "Budget",
        rightDataTitlei18n: "Budget",
        dataFilter: "KPI_M_k_formatter"
      }
    }
  }
}
  
